// Port of api/fuel/app/classes/filter/search/games/filters/query/collection/nested.php
import F from 'offline/filter/constants'

export default {
	name: 'collection.nested',
	priority: 6,
	require: function(config, filter) {
		// PHP truthiness: `if($filter['nested'])` treats `[]` as falsy.
		// JS `[]` is truthy, so an explicit length check matches PHP.
		var nestedActive = Array.isArray(filter.nested) ? filter.nested.length > 0 : !!filter.nested
		return nestedActive || filter.nestChild || filter.nestParent
	},
	run: function(config, filter, _data, query) {
		var isAuto = !!(((config.settings || {}).session || {}).collection || {}).nest

		if (config.ownerType === F.OWNER_USER) {
			if (Array.isArray(filter.nested)) {
				if (isAuto) {
					query.whereGroup('OR', [
						['AND', [
							['c.collection_nested', '=', F.NESTED_OFFICIAL],
							['c.collection_nested_official', 'in', filter.nested]
						]],
						['AND', [
							['c.collection_nested', '=', F.NESTED_CUSTOM],
							['c.collection_nested_custom', 'in', filter.nested]
						]]
					])
				} else {
					query.where('c.collection_nested', '=', F.NESTED_CUSTOM)
					query.where('c.collection_nested_custom', 'in', filter.nested)
				}
			} else if (filter.nestParent) {
				query.where('c.collection_nested', '=', F.NESTED_NONE)
			} else {
				query.where('c.collection_nested', '>=', isAuto ? F.NESTED_OFFICIAL : F.NESTED_CUSTOM)
			}

			if (filter.orphans && filter.orphans.length) {
				query.where('c.collection_id', 'not in', filter.orphans)
			}
		} else {
			if (isAuto) {
				query.where('c.collection_expansion', '=', 1)
				if (filter.orphans && filter.orphans.length) {
					query.where('c.game_id', 'not in', filter.orphans)
				}
			}
		}
	}
}
